import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';

import styled from 'styled-components';

import { BaseComponent } from 'components/BaseComponent';

import { removeApiError } from '../actions';
import { selectErrors } from '../selectors';
import { Button } from '../../../components/Buttons';
import { HBox } from '../../../components/Box';
import { REQUEST_API_KEY } from '../constants';

const Container = styled.div`
  padding: 12px;

  width: 100%;
  border: 1px solid red;
  background-color: #ffeaea;
  z-index: 2;
`;
/* eslint-disable react/prefer-stateless-function */
class ErrorsComp extends BaseComponent {
  constructor(props) {
    super(props, {});
  }

  renderError(error, index) {
    return (
      <div key={index} className="error">
        <HBox vCenter>
          <div className="label">{error.message ? error.message : this.lbl(`error.${error.id}`)}</div>
          <Button small onClick={() => this.props.removeError(error.id)}>
            x
          </Button>
        </HBox>
      </div>
    );
  }

  render() {
    const ignore = [REQUEST_API_KEY];
    let errors = _.reject(this.props.errors, error => _.indexOf(ignore, error.id) > -1);
    if (!errors || !errors.length) return '';
    return (
      <Container>
        <div className="general errors">{errors.slice(0, 2).map(this.renderError.bind(this))}</div>
      </Container>
    );
  }
}

ErrorsComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    errors: selectErrors(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    removeError(id) {
      dispatch(removeApiError(id));
    },
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const Errors = compose(withConnect)(ErrorsComp);
